/* tslint:disable */
/* eslint-disable */
/**
 * SISCC Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DisplayPrice,
    DisplayPriceFromJSON,
    DisplayPriceFromJSONTyped,
    DisplayPriceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ItemState
 */
export interface ItemState {
    /**
     * 
     * @type {string}
     * @memberof ItemState
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ItemState
     */
    selected: boolean;
    /**
     * 
     * @type {DisplayPrice}
     * @memberof ItemState
     */
    price?: DisplayPrice;
}

export function ItemStateFromJSON(json: any): ItemState {
    return ItemStateFromJSONTyped(json, false);
}

export function ItemStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ItemState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'selected': json['selected'],
        'price': !exists(json, 'price') ? undefined : DisplayPriceFromJSON(json['price']),
    };
}

export function ItemStateToJSON(value?: ItemState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'selected': value.selected,
        'price': DisplayPriceToJSON(value.price),
    };
}


